// extracted by mini-css-extract-plugin
export var content = "_2m-3";
export var contentWrapper = "_2m-2";
export var fullWidthButton = "_2m-4";
export var heroImage = "_2m-6";
export var logo = "_2m-1";
export var logoContainer = "_2m-0";
export var panel = "_2m-5";